import { render, staticRenderFns } from "./brandDetail.vue?vue&type=template&id=6db55e90&scoped=true&"
import script from "./brandDetail.vue?vue&type=script&lang=js&"
export * from "./brandDetail.vue?vue&type=script&lang=js&"
import style0 from "./brandDetail.vue?vue&type=style&index=0&id=6db55e90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db55e90",
  null
  
)

export default component.exports